export default __webpack_public_path__ + "static/media/logo-tla-centered-light.d7a55970.svg";